<template>

    <div class="search-nav search-area default">

        <form @submit.prevent action="" class="search">
            <div class="div-search">
                <input class="searchbox" @focus="onFocus" @keyup="search" @keyup.enter="redirectToFilter" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" v-model="searchValue" type="text" placeholder="جستجوی محصول...">
                <div v-show="isShowRemoveSearchbtn"> <i @click="removeSearchValue" class="now-ui-icons ui-1_simple-remove btn-remove-search"></i></div>
            </div>
            <button @click="redirectToFilter" type="button"><img src="/assets/img/search.png" alt="جستجو"></button>


            <div @click="closeTransparentDiv" class="transparent-div" v-show="isShowSearchResult   && !(searchValue == null || searchValue == '')" v-if="searchResult.SubGroups != null && searchResult.Tags != null && searchResult.SubGroups != null"></div>
            <div class="c-search__results js-search-results is-active" v-show="isShowSearchResult   && !(searchValue == null || searchValue == '')" v-if="searchResult.SubGroups != null && searchResult.Tags != null && searchResult.SubGroups != null">

                <ul v-if="searchResult.SubGroups.length == 0 && searchResult.Products.length == 0 &&  searchResult.Tags.length == 0" class="js-autosuggest-empty-list c-search__results-list">
                    <li>
                        <a class="js-search-keyword-link">
                            <span class="c-search__result-item">نتیجه ایی یافت نشد </span>
                            <span class="c-search__result-item--category js-search-keyword"></span>
                        </a>
                    </li>
                </ul>
                <div v-else class="c-search__results-footer">
                    <ul class="c-search">
                        <li v-for="subGroup in searchResult.SubGroups"><a @click="filterBySubGroup(subGroup.Id , subGroup.Title.replace(/\s+/g, '-'))" :title="searchValue + ' در زیر گروه ' + subGroup.Title">{{ searchValue }} در زیر گروه <span class="ctaegoryname">{{subGroup.Title}}</span></a></li>
                    </ul>
                    <hr v-if="searchResult.Products.length != 0" />
                    <ul class="c-search">
                        <li v-for="product in searchResult.Products"><a @click="filterBySearch(product.Title)" :title="product.Title">{{product.Title}}</a></li>
                    </ul>
                    <hr v-if="searchResult.Tags.length != 0 " />
                    <ul class="c-search__results-trends cearchtags">
                        <li v-for="tag in searchResult.Tags"><a @click="filterByTag(tag.Id , tag.Title.replace(/\s+/g, '-'))" :title="tag.Title">{{tag.Title}}</a></li>
                    </ul>
                </div>
            </div>


        </form>
        <ul class="info-login">
            <li v-if="isUserLogined"><router-link to="/info"><i class="now-ui-icons users_single-02"></i></router-link></li>
            <li v-if="!isUserLogined"><router-link to="/login"><i class="now-ui-icons users_single-02"></i></router-link></li>
            <li><router-link to="/cart"><i class="now-ui-icons shopping_basket"></i></router-link></li>
        </ul>
    </div>
</template>

<script>
    import { httpPromise } from "../../../module/httpUtility";
    export default { 
        data() {
            return {
                searchValue: '',
                searchResult: {},
                isShowSearchResult: true,
                isShowRemoveSearchbtn: false,
                isShowSppiner: false,
                isUserLogined: false
            }
        },
        watch: {
            searchValue: function (newValue, oldValue) {
                if (IsNullOrEmptyString(newValue)) {
                    this.isShowSearchResult = false;
                    this.isShowRemoveSearchbtn = false;
                }
                else {
                    this.isShowSearchResult = true;
                    this.isShowRemoveSearchbtn = true;
                }
            },
            '$route': function (from, to) {
                this.searchValue = this.$route.query.SearchValue == null ? '' : this.$route.query.SearchValue;
            }
        },
        methods: {
            closeTransparentDiv() {
                this.isShowSearchResult = false;
                this.isShowRemoveSearchbtn = false;
            }, 
            onFocus() {
                this.isShowSearchResult = true;
                this.isShowRemoveSearchbtn = true;
            },
            removeSearchValue() {
                this.searchValue = '';
            },
            search() {
                this.isShowSppiner = true;
                if (!IsNullOrEmptyString(this.searchValue)) {
                    httpPromise(this, '/v1/ProductManagement/Search/Read?SearchValue=' + this.searchValue, 'get', '',
                        response => {
                            toastr.remove();
                            this.searchResult = response.data.Value;
                            this.isShowSearchResult = true;
                            this.isShowSppiner = false;
                        },
                        response => {
                            toastr.remove();
                            toastr.error(response.data.Message);
                            this.isShowSppiner = false;
                        });
                }
            },
            filterByTag(id, name) {
                this.$router.push({ name: 'filter', query: { TagId: id, TagName: name } });
                this.isShowSearchResult = false;
            },
            filterBySubGroup(id, name) {
                this.$router.push({ name: 'filter', query: { SubGroupId: id, SubGroupName: name } });
                this.isShowSearchResult = false;
            },
            filterBySearch(name) {
                this.$router.push({ name: 'filter', query: { SearchValue: name } });
                this.isShowSearchResult = false;
            },
            redirectToFilter() {
                    toastr.remove();
                this.$router.push({ name: 'filter', query: { SearchValue: this.searchValue } });
            }
        },
        beforeMount() {
            this.searchValue = this.$route.query.SearchValue == null ? '' : this.$route.query.SearchValue;
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
        //mounted() {
        //    window.addEventListener('keyup', function (event) {
        //        if (event.keyCode === 13) {
        //            redirectToFilter()
        //        }
        //    });
        //}
    }
</script>

<style scoped>
    .transparent-div {
        position: fixed;
        right: -999999px;
        left: -999999px;
        top: -999999px;
        bottom: -999999px;
        background-color: transparent;
        z-index: 9999997;
    }

    ul li a {
        cursor: pointer;
    }

    .btn-remove-search {
        z-index: 9999998;
    }

    .search-area ul.info-login {
        display: none;
    }

    @media only screen and (min-width:850px) and (max-width: 1077px) {
        ul.js-autosuggest-empty-list {
            width: 100% !important;
            float: right !important;
        }

            ul.js-autosuggest-empty-list li {
                float: right !important;
                line-height: 1.5 !important;
            }

        nav.header-responsive .search-nav {
            top: 8px;
        }

        .search-area form {
            position: relative;
            direction: rtl;
            float: right;
            width: 100%;
            height: 45px;
        }

        .search-area {
            position: absolute;
            top: 0px;
            height: 40px;
            width: 63%;
            right: 40px;
        }

            .search-area ul.info-login {
                display: block;
            }

            .search-area ul.info-login {
                font-size: 14px !important;
                position: relative;
                top: -43px;
                left: -95px;
            }

                .search-area ul.info-login li {
                    float: left;
                    text-align: right;
                }

        .search-nav ul.c-search {
            width: 100%;
            float: none !important;
        }

            .search-nav ul.c-search li {
                line-height: 1.5;
                text-align: right;
                float: none !important;
            }

            .search-nav ul.c-search a {
                font-size: 13px;
                color: #212121 !important;
                background: transparent;
            }

        .c-search__results ul.cearchtags li a {
            font-size: 13px !important;
            padding: 0 !important;
        }

        .c-search__results .cearchtags {
            width: 100% !important;
        }

        .c-search__results ul.cearchtags li {
            height: 26px;
            border-radius: 13px;
            background-color: #eceff1;
            display: flex;
            margin-top: 15px;
            margin-left: 15px;
            padding: 8px;
            justify-content: center;
            align-items: center;
            float: right !important;
        }
    }

    @media only screen and (min-width:640px) and (max-width: 850px) {
        ul.js-autosuggest-empty-list {
            width: 100% !important;
            float: right !important;
        }

            ul.js-autosuggest-empty-list li {
                float: right !important;
                line-height: 1.5 !important;
            }

        nav.header-responsive .search-nav {
            top: 8px;
        }

        .search-area form {
            position: relative;
            direction: rtl;
            float: right;
            width: 100%;
            height: 45px;
        }

        .search-area {
            position: absolute;
            top: 0px;
            height: 40px;
            width: 63%;
            right: 40px;
        }


            .search-area ul.info-login {
                font-size: 14px !important;
                position: relative;
                top: -43px;
                left: -95px;
            }

                .search-area ul.info-login li {
                    float: left;
                    text-align: right;
                }

        .search-nav ul.c-search {
            width: 100%;
            float: none !important;
        }

            .search-nav ul.c-search li {
                line-height: 1.5;
                text-align: right;
                float: none !important;
            }

            .search-nav ul.c-search a {
                font-size: 13px;
                color: #212121 !important;
                background: transparent;
            }

        .c-search__results ul.cearchtags li a {
            font-size: 13px !important;
            padding: 0 !important;
        }

        .c-search__results .cearchtags {
            width: 100% !important;
        }

        .c-search__results ul.cearchtags li {
            height: 26px;
            border-radius: 13px;
            background-color: #eceff1;
            display: flex;
            margin-top: 15px;
            margin-left: 15px;
            padding: 8px;
            justify-content: center;
            align-items: center;
            float: right !important;
        }
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        ul.js-autosuggest-empty-list {
            width: 100% !important;
            float: right !important;
        }

            ul.js-autosuggest-empty-list li {
                float: right !important;
                line-height: 1.5 !important;
            }

        .search-area {
            position: absolute;
            top: 50px;
            height: 40px;
            width: 100%;
        }

            .search-area form {
                position: relative;
                direction: rtl;
                float: right;
                width: 100%;
                height: 45px;
            }

            .search-area ul.info-login {
                display: block;
            }

                .search-area ul.info-login li {
                    float: left;
                }

        .search-nav ul {
            width: 100%;
        }

            .search-nav ul.c-search {
                width: 100%;
                float: none;
            }

                .search-nav ul.c-search li {
                    line-height: 1.5;
                }

                .search-nav ul.c-search a {
                    font-size: 13px;
                    color: #212121 !important;
                    background: transparent;
                }

        ul.c-search li {
            float: none !important;
            text-align: right !important;
        }

        .search-area ul.info-login {
            font-size: 14px !important;
            position: relative;
            top: -92px;
            left: 104px;
        }

        .c-search__results {
            padding: 0 3px;
        }

            .c-search__results .cearchtags {
                width: 100% !important;
            }

            .c-search__results ul.cearchtags li {
                height: 26px;
                border-radius: 13px;
                background-color: #eceff1;
                display: flex;
                margin-top: 15px;
                margin-left: 15px;
                padding: 8px;
                justify-content: center;
                align-items: center;
                float: right !important;
            }

                .c-search__results ul.cearchtags li a {
                    font-size: 13px !important;
                    padding: 0 !important;
                }
    }
    nav.header-responsive form button {
        width: 60px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        border: none;
        border-radius: 7px 0 0 7px;
        background-color: #a5cd39;
        cursor: pointer;
        outline: none;
    }
</style>